<script lang="ts">
    import { assets as assetPath } from "$app/paths";
    import Container from "../containers/Container.svelte";
    import CTA from "../elements/CTA.svelte";
    import ListBlock from "../elements/ListBlock.svelte";
    import ParagraphBlock from "../elements/ParagraphBlock.svelte";
    import AccordionBlock from "../elements/AccordionBlock/AccordionBlock.svelte";
    import { PortableText } from "@portabletext/svelte";
    import InfoBanner from "../elements/InfoBanner.svelte";
    import type { ImageType, CTA as CTA_TYPE } from "../../types";

    export let blockContent : any;
    export let heading: string;
    export let introductionParagraph : [] = []
    export let showBanner : boolean  = false
    export let bannerImage : ImageType = {pngUrl: ''}
    export let bannerHeading : string  = ''
    export let bannerContent : string = ''
    export let bannerCTA : CTA_TYPE = {text: ''}
    export let ctas : CTA_TYPE[] = []
    export let ctaHeading : string = ''

    let showContent: boolean = false;
    let hasAccordion = blockContent.filter(block => block.type === 'accordion');


    const handleShowContent = () => {
        showContent = !showContent;
    }
</script>

<Container background="white" padding="none">
    <div class="developer-requirements">
        <h2 style:margin={introductionParagraph.length !== 0 ? '0px 0px 24px' : 'inherit'}>{@html heading}</h2>
        {#if introductionParagraph}
            <div class="developer-requirements__paragraph">
                <PortableText
                    value={introductionParagraph}
                    components={{marks: {link: URL}}}
                />
            </div>
        {/if}
        <div class="developer-requirements__content {showContent ? 'developer-requirements__content--show' : ''}" style:height={hasAccordion.length !== 0 ? '100%' : ''}>
            {#each blockContent as block}
                <div class="developer-requirements__block">
                    {#if block.show_heading}<h3>{block.heading}</h3>{/if}
                    {#if block.type === "list"}
                        <ListBlock listItems={block.content}/>
                    {:else if block.type === 'paragraph'}
                        <ParagraphBlock paragraphItems={block.content}/>
                    {:else if block.type === 'accordion'}
                        <AccordionBlock accordionItems={block.accordion}/>
                    {/if}
                </div>
            {/each}
        </div>
            <div class="developer-requirements__CTA {showContent && !hasAccordion.length ? 'developer-requirements__CTA--show' : ''} {hasAccordion.length === 1 ? 'developer-requirements__CTA--extend' : ''}">
                {#if !showBanner}
                    {#if !showContent && !hasAccordion.length}<button on:click={handleShowContent}>Read more<img src="{assetPath}/assets/blue-arrow.svg" alt="A blue arrow indicator"></button>{/if}
                    <h3>{#if ctaHeading}{ctaHeading}{:else}Ready to get started?{/if}</h3>
                    <div class="developer-requirements__CTA__buttons">
                        {#if ctas.length}
                            {#each ctas as cta}
                                <CTA text={cta.text} url={cta.url}/>
                            {/each}
                        {:else}
                            <CTA text="Get access to developers" url="https://www.offerzen.com/hire/get-started"/>
                            <CTA text="Book a demo" url="https://www.offerzen.com/hire/book-call" theme="outlined-blue"/>
                        {/if}
                    </div>
                {:else}
                    <InfoBanner heading={bannerHeading} content={bannerContent} image={bannerImage} cta={bannerCTA} theme="light"/>
                {/if}
            </div>
        </div>
</Container>
<style lang="postcss">
    @import '../../styles/_mixins.css';
    .developer-requirements {

        display: flex;
        flex-direction: column;
        align-items: center;
        color:var(--color_offerzen_navy);
        position: relative;
        padding:0px 0 120px;

        @mixin screen-lg {
            padding:0px 0 100px;
        }

        @mixin screen-md {
          padding:0px 60px 100px;
          align-items: flex-start;
        }

        @mixin screen-sm {
            padding:60px 24px;
        }

        & h2 {
            @mixin heading-h2;
            margin:0 0 60px;

            @mixin screen-lg {
                text-align:center;
            }

            @mixin screen-sm {
                text-align:left;
                margin:0 0 40px;
            }

            & :global(span) {
                color: var(--color_offerzen_cerulean);
            }
        }

        & .developer-requirements__paragraph {
            max-width:600px;
            text-align:center;
            margin:0 0 80px;

            @mixin screen-sm {
                text-align:left;
                margin:0 0 40px;
            }

            & :global(p) {
                margin:0;
                font-size:18px;
                line-height:150%;

                @mixin screen-sm {
                    line-height:140%;
                }
            }
        }

        & .developer-requirements__content {
            height: 700px;
            overflow: hidden;

            @mixin screen-sm {
                height:500px;
            }
        }

        & .developer-requirements__content--show {
            height:100%;
        }

        & .developer-requirements__block {
            max-width:800px;
            margin:0px 0px 40px;

            @mixin screen-md {
                max-width:100%;
            }

            @mixin screen-sm {
                max-width:100%;
                margin:0 0 60px;
            }

            & h3 {
                @mixin heading-h3;
                margin:0 0 8px;
            }

            & :global(ul) {
                margin:0;
                padding: 0 0 0 25px;
                @mixin paragraph;

                & :global(li) {
                    padding:5px 0;

                    @mixin screen-md {
                        padding:5px 0 0px;
                    }
                }
            }

            & :global(a) {
                color:var(--color_offerzen_cerulean);
                text-decoration: none;
            }
        }

        & .developer-requirements__CTA {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin-top:-100px;
            padding-top:100px;
            background: linear-gradient(
                to bottom,
                transparent 0%,
                var(--color_white) 30%,
                var(--color_white) 50%,
                var(--color_white) 100%
            );
            width:100%;

            & button {
                align-self: flex-start;
                color: var(--color_offerzen_cerulean);
                background:none;
                text-decoration:none;
                font-weight:700;
                border:none;
                font-size:20px;
                display:flex;
                align-items:center;
                margin:24px 0 60px;

                & img {
                    transform: rotate(90deg);
                    margin:0 0 0 12px;
                    height:15px;
                }

                @mixin screen-sm {
                    max-width:100%;
                }
            }

            & h3 {
                @mixin heading-h3;
                margin:0 0 24px;
            }

            & .developer-requirements__CTA__buttons {
                display:flex;
                gap:24px;

                @mixin screen-sm {
                    flex-direction:column;
                    width:100%;
                }
            }
        }

        & .developer-requirements__CTA--extend {
            margin:60px 0 0;
            padding-top:0;

            @mixin screen-md {
                margin:40px 0 0;
            }
        }

        & .developer-requirements__CTA--show {
            padding-top:40px;
            margin-top:0;
            background: var(--color_white);
        }
    }

</style>